// platform-password-recovery: מעטפת משותפת לדפי /login/forgot ו-/login/reset. web-visual-identity: רקע בהיר, לוגו למעלה,
// כרטיס לבן אחד בפינות 8, בלי זוהר ובלי רשת נקודות.
import type { ReactNode } from 'react';
import { T } from '../lib/strings.ts';
import { Logo } from './brand/Logo.tsx';
import { useDocTitle } from '../lib/brand.ts';

export function AuthCard({ title, lead, testId, children }: { title: string; lead?: string; testId: string; children: ReactNode }) {
  useDocTitle(title); // web-instance-identity: "<עמוד> · <שם הסביבה>"
  return (
    <main className="grid min-h-(--ab-screen) grid-cols-1 bg-background text-foreground">
      <section className="flex flex-col items-center gap-8 px-4 pt-8 pb-10 sm:justify-center sm:px-10" aria-label={T.brand}>
        <Logo className="h-10 sm:h-12" />
        <div className="w-full max-w-[26rem]">
          <div className="rounded-md border border-border bg-card p-6 text-foreground sm:p-8" data-testid={testId}>
            <h1 className="m-0 mb-1 text-2xl font-semibold">{title}</h1>
            {lead && <p className="m-0 mb-6 text-sm text-muted-foreground">{lead}</p>}
            {children}
          </div>
        </div>
      </section>
    </main>
  );
}
